export default "__VITE_PUBLIC_ASSET__30756949__"